import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The warehouse runs on phones on a patchy signal; a failed read should retry rather than
      // show an error the moment the lift door closes.
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
